<rask-kontrakt-search-mina-filter></rask-kontrakt-search-mina-filter>
<form [formGroup]="form" (ngSubmit)="onSearch()">
    <div class="row flex-nowrap align-items-start">
        @if (virkeskopareSokBehorighet) {
        <rask-multi-selector
            aid="inputAnsvarigVirkeskopare"
            class="col-2"
            label="Ansvarig Virkesköpare"
            bindLabel="namn"
            formControlName="ansvarigVirkeskopare"
            typeToSearchText="Ange minst tre tecken"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="getAnvandareTypeAhead"
            [selected]="form.value.ansvarigVirkeskopare"></rask-multi-selector>
        }
        @else {
        <rask-multi-selector
            aid="inputAnsvarigVirkeskopare"
            class="col-2"
            label="Ansvarig Virkesköpare"
            bindLabel="namn"
            formControlName="ansvarigVirkeskopare"
            [items]="disabledAnsvarigVirkeskopare$"
            [selected]="form.value.ansvarigVirkeskopare"></rask-multi-selector>
        }

        <rask-multi-selector
            aid="inputAnsvarigFaltplanerare"
            class="col-2"
            label="Ansvarig Fältplanerare"
            bindLabel="namn"
            formControlName="ansvarigFaltplanerare"
            typeToSearchText="Ange minst tre tecken"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="getAnvandareTypeAhead"
            [selected]="form.value.ansvarigFaltplanerare"></rask-multi-selector>

        <rask-input
            aid="virkeskopKontraktSokAOBeteckning"
            class="col-2"
            label="Arbetsorderbeteckning"
            formControlName="arbetsorderbeteckning"
            placeholder="Skriv in AO-beteckning"></rask-input>

        <rask-input
            aid="virkeskopKontraktSokFritext"
            class="col-2"
            label="Fritext sök"
            placeholder="Ange sökterm"
            value="sok"
            type="text"
            formControlName="sok"></rask-input>

        <div class="d-flex pt-3 col">
            <rask-submit-button
                aid="buttonVirkeskopKontraktSok"
                color="primary">
                Sök</rask-submit-button>

            <rask-button
                aid="buttonVirkeskopKontraktRensa"
                (click)="onClear()"
                negative
                color="secondary">
                Rensa
            </rask-button>
        </div>

        <div class="col-2">
            <rask-kontrakt-save-filter></rask-kontrakt-save-filter>
        </div>
    </div>

    <div class="row">
        <rask-simple-selector
            class="col-2"
            label="Kontraktstyp"
            [values]="kontrakstyper"
            [clearable]="true"
            formControlName="kontraktstyp">
        </rask-simple-selector>

        <rask-tree-selector
            class="col-2"
            label="Status"
            [items]="kontraktstatusar"
            formControlName="kontraktstatus">
        </rask-tree-selector>

        <rask-tree-selector
            class="col-2"
            label="Planeringsstatus"
            [items]="atgardPlaneringstatusar"
            formControlName="planeringsstatus">
        </rask-tree-selector>

        <rask-tree-selector
            class="col-3"
            [label]="atgardTypsRubrik"
            [items]="atgardstypItems"
            (change)="atgardsTyperChanged()"
            [autoSort]="false">
        </rask-tree-selector>
    </div>

    <div class="row">
        <rask-simple-selector
            class="col-2"
            label="Anskaffningsform"
            [values]="anskaffingsformer"
            [clearable]="true"
            formControlName="anskaffningsform">
        </rask-simple-selector>

        <rask-tree-selector
            class="col-2"
            label="Affärsform"
            [items]="affarsformer"
            [autoSort]="false"
            formControlName="affarsform"></rask-tree-selector>

        <rask-tree-selector
            class="col-2"
            label="Status i VACS"
            [items]="vacsKontraktstatusar"
            formControlName="vacsStatus">
        </rask-tree-selector>

        <rask-tree-selector
            class="col-2"
            label="Skogsvård"
            [items]="skogsvardsItems"
            (change)="atgardsTyperChanged()"
            [autoSort]="false">
        </rask-tree-selector>
        <rask-multi-selector
            class="col-2"
            label="Skogsvårds status"
            [items]="skogsvardsStatusItems"
            bindLabel="text"
            (change)="onSkogsvardsStatusChanged($event)"
            [viewFormatter]="skogsvardViewFormatterFn"
            [selected]="skogsvardsStautsSelection">
        </rask-multi-selector>

        <div class="col-3 px-0">
            <rask-checkbox
                label="Transportstatus"
                text="Sluttransporterat"
                formControlName="sluttransporterat">
            </rask-checkbox>
        </div>
    </div>
</form>